// Bell notification sound
const bellAudio = new Audio('https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3');

// Function to play the bell sound
export const playBellSound = () => {
  try {
    // Reset the audio to the beginning
    bellAudio.currentTime = 0;
    // Play the sound
    bellAudio.play().catch(err => {
      // Handle autoplay restrictions or other errors
      console.warn("Could not play notification sound:", err);
    });
  } catch (error) {
    console.error("Error playing notification sound:", error);
  }
};

export default playBellSound; 